import api from "@/api/comptabilite/_rapport_caisse";
import AdminFinanceOverview from '@/components/comptable/dashboard/admin-finance-overview'
import DateFilter from '@/components/date-filter';
import RapportRecette from '@/components/comptable/dashboard/rapport-recette'
import RapportVente from '@/components/comptable/dashboard/rapport-vente'
// import RapportTouteDepenseCaisse from '@/components/comptable/dashboard/rapport-toutes-depenses'
// import RapportDepenseCaisse from '@/components/comptable/dashboard/rapport-depense-caisse'
// import RapportDepenseCaisseAnnulee from '@/components/comptable/dashboard/rapport-depense-caisse-annulee'
import RapportVersement from '@/components/comptable/dashboard/rapport-versement'
import RapportReportReliquat from '@/components/comptable/dashboard/rapport-report-reliquat'
import RapportReglementReliquat from '@/components/comptable/dashboard/rapport-reglement-reliquat'
import RapportAnnulation from '@/components/comptable/dashboard/rapport-annulation'
// import RapportApportSocial from '@/components/comptable/dashboard/rapport-apport-social'
import RapportCoupon from '@/components/comptable/dashboard/rapport-coupon'
import RapportCreance from '@/components/comptable/dashboard/rapport-creance'
import RapportEcartCaisse from '@/components/comptable/dashboard/rapport-ecart-caisse'

import $ from 'jquery'

// RapportDepenseCaisse, RapportDepenseCaisseAnnulee, RapportApportSocial, RapportTouteDepenseCaisse

export default {
    name: 'tab-finance',
    components: {
        AdminFinanceOverview,
        DateFilter, RapportRecette, 
        RapportVersement, RapportReportReliquat, RapportReglementReliquat, 
        RapportAnnulation,  RapportCoupon, RapportCreance,
        RapportEcartCaisse, RapportVente
    },
    props: {
        liste_personnel_roles: Array
    },

    data() {
        return {
            rapport_caisse: {},
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            personnel_id: "",
            personnel: '',

            type_produits: [
                { 'data_type': 'tous', 'libelle': 'Tous les produits' },
                { 'data_type': 'bon_consultation', 'libelle': 'Consultations' },
                { 'data_type': 'analyse', 'libelle': 'Analyses' },
                { 'data_type': 'examen', 'libelle': 'Examens' },
                { 'data_type': 'medicament', 'libelle': 'Médicaments' },
                { 'data_type': 'consommable', 'libelle': 'Consommables' },
                { 'data_type': 'chirurgie', 'libelle': 'Chirurgies' },
                { 'data_type': 'bilan_sante', 'libelle': 'Bilan de santé' },
                { 'data_type': 'admission', 'libelle': 'Admissions' },
                { 'data_type': 'acte', 'libelle': 'Actes' },
                { 'data_type': 'observation', 'libelle': 'Observations' },
                { 'data_type': 'chambre', 'libelle': 'Chambres' },
                { 'data_type': 'consommable_bon', 'libelle': 'Consommables de bon de consultation' },
            ],
            filter_type_produit: { 'data_type': 'tous', 'libelle': 'Tous les produits' },
            operation_loading: true,
            compte_id: 1,
            solde_av_versement: 0,
            solde_ap_versement: 0,
            recette: 0,
            total_vente: 0,
            total_annulation: 0,
            total_coupon: 0,
            total_creance: 0,
            total_ecart_caisse: 0,

            filter_creances: [
                { etat_paiement: 'tout', libelle: 'Créances' },
                { etat_paiement: 'diferee', libelle: 'Différées' },
                { etat_paiement: 'restant', libelle: 'Reste à payer' }
            ],
            selected_creance: 'Créances',

            filter_ecarts_caisse: [
                { libelle: 'Écarts caisse' },
                { libelle: 'Écarts positifs' },
                { libelle: 'Écarts négatifs' }
            ],
            selected_ecart: 'Écarts caisse',
            by_type_ecart: '',

            liste_prestations: [
                { 'libelle': 'Tout' }
            ],
            filter_prestation: { 'libelle': 'Tout' },
            can_filter_by_prestation: false,
            is_na: false,
            modal_toggler: 0,
            rapport_filter: {},       // Filtre utilisé pour les totaux affichés (réutilisé pour charger les listes)
            rapport_request_id: 0,    // Ignore les réponses d'un filtre devenu obsolète
            sections_chargees: {},    // Listes déjà chargées pour le filtre courant
            section_loading: '',
            by_prestation: '',
            by_type_creance: ''
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.personnel_id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                filter_option: this.filter_type_produit,
                libelle: this.filter_prestation.libelle
            }
            this.current_date_filter = data
            this.is_month = true
            this.getRapportCaisses()
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.current_date_filter.filter_option = this.filter_type_produit
            this.getRapportCaisses()
        },

        filter_type_produit() {
            this.liste_prestations = [{ 'libelle': 'Tout' }]
            this.filter_prestation = { 'libelle': 'Tout' }
            this.current_date_filter.filter_option = this.filter_type_produit
            this.current_date_filter.libelle = this.filter_prestation.libelle
            if (this.filter_type_produit.data_type == 'tous') {
                this.can_filter_by_prestation = false
                this.is_na = false
            } else {
                this.can_filter_by_prestation = true
                this.is_na = true
            }

            this.getRapportCaisses()
        },

        filter_prestation() {
            this.selected_creance = 'Créances'
            this.current_date_filter.libelle = this.filter_prestation.libelle
            // this.calcRapportPrestation()

            if (this.filter_prestation.libelle == 'Tout') {
                this.by_prestation = ''
            } else {
                this.by_prestation = this.filter_prestation.libelle
            }
        },

        selected_creance() {
            this.handleCreance()
        },

        selected_ecart() {
            this.handleEcartCaisse()
        }
    },

    computed: {
        activeRole() { return this.$store.getters['activeRole'] || {} },
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        solde_du_jour() {
            return this.$store.getters["solde_du_jour"];
        },
    },

    mounted () {
        const data = {
            compte_id: this.compte_id,
            user_id: this.personnel_id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        if (this.activeRole.nom !== 'ROLE_ADMINISTRATEUR') this.getRapportCaisses()

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        selectRapportCaisse(data) {
            return new Promise((resolve, reject) => {
                api.getRapportCaisse(data).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },

        getRapportCaisses() {
            this.selected_creance = 'Créances'
            this.selected_ecart = 'Écarts caisse'
            this.by_type_ecart = ''
            this.recette = 0
            this.total_vente = 0
            this.solde_av_versement = 0
            this.solde_ap_versement = 0
            this.operation_loading = true
            this.rapport_caisse = {}
            this.sections_chargees = {}
            this.section_loading = ''

            // Seuls les totaux sont chargés ici, les listes le sont à l'ouverture de chaque fenêtre
            const request_id = ++this.rapport_request_id
            this.rapport_filter = JSON.parse(JSON.stringify(this.current_date_filter))
            this.selectRapportCaisse({ ...this.rapport_filter, mode: 'totaux' }).then((rapport) => {
                if (request_id != this.rapport_request_id) return

                this.rapport_caisse = rapport
                this.total_annulation = rapport.total_annulation
                this.total_coupon = rapport.total_coupon
                this.total_creance = rapport.total_creance
                this.total_ecart_caisse = rapport.total_ecart_caisse


                // Recette
                this.recette = rapport.total_recette
                this.total_vente = rapport.total_vente

                // Solde avant versement
                this.solde_av_versement = rapport.total_recette - rapport.total_depense_caisse

                // Solde apres versement
                this.solde_ap_versement = this.solde_av_versement - rapport.total_versement

                if (this.filter_type_produit.data_type != 'tous') {
                    this.liste_prestations = [{ 'libelle': 'Tout' }]
                    rapport.libelles_prestations.forEach(libelle => {
                        this.liste_prestations.push({ libelle: libelle })
                    });
                }

                this.operation_loading = false
            })
        },

        /**
         * Charge (une seule fois par filtre) la liste d'une section puis ouvre sa fenêtre
         * @param {String} section Clé de la liste dans rapport_caisse
         * @param {String} modal Sélecteur de la fenêtre à ouvrir
         */
        openSection(section, modal) {
            const show = () => {
                this.modal_toggler = (this.modal_toggler == 0)?1:0
                $(modal).modal('show')
            }

            if (this.sections_chargees[section]) {
                show()
                return
            }
            if (this.operation_loading || this.section_loading != '') return

            const request_id = this.rapport_request_id
            this.section_loading = section
            this.selectRapportCaisse({ ...this.rapport_filter, mode: 'section', section: section }).then((response) => {
                if (request_id != this.rapport_request_id) return

                this.rapport_caisse[section] = response[section]
                this.$set(this.sections_chargees, section, true)
                this.section_loading = ''
                this.$nextTick(show)
            }, () => {
                this.section_loading = ''
            })
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.personnel_id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                filter_option: this.filter_type_produit,
                libelle: this.filter_prestation.libelle
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getRapportCaisses()
        },

        viewRecette() {
            this.openSection('recettes', '.rapport-recette')
        },
         
        viewDepenseCaisse() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-depense-caisse').modal('show')  
        },

        viewVersement() {
            this.openSection('versements', '.rapport-versement')
        },

        viewReportReliquat() {
            this.openSection('report_reliquats', '.rapport-report-reliquat')
        },

        viewReglementReliquat() {
            this.openSection('reglement_reliquats', '.rapport-reglement-reliquat')
        },

        viewAnnulation() {
            this.openSection('annulations', '.rapport-annulation')
        },

        viewApportSociaux() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-apport-social').modal('show') 
        },

        viewCoupon() {
            this.openSection('coupons', '.rapport-coupon')
        },
        
        viewCreance() {
            this.openSection('creances', '.rapport-creance')
        },

        viewEcartCaisse() {
            this.openSection('ecarts_caisse', '.rapport-ecart-caisse')
        },

        viewVente() {
            this.openSection('ventes', '.rapport-vente')
        },

        viewDepenseCaisseAnnulee() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-depense-caisse-annulee').modal('show') 
        },

        viewAllDepenseCaisse() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            $('.rapport-toutes-depenses').modal('show')
        },

        handleCreance() {
            let etat_paiement = ''
            if (this.selected_creance == 'Créances') {
                etat_paiement = 'tout'
            } else if (this.selected_creance == 'Différées') {
                etat_paiement = 'diferee'
            } else if (this.selected_creance == 'Reste à payer') {
                etat_paiement = 'restant'
            }   
            this.by_type_creance = etat_paiement

            // Totaux agrégés par libellé et état de paiement (renvoyés avec les totaux du rapport)
            this.total_creance = 0
            const creances_totaux = this.rapport_caisse.creances_totaux || []
            creances_totaux.forEach(creance => {
                if (etat_paiement != 'tout' && creance.etat_paiement != etat_paiement) return

                if (this.filter_prestation.libelle == creance.libelle || this.filter_prestation.libelle == 'Tout') {
                    this.total_creance += creance.montant_a_payer
                }
            });
        },

        handleEcartCaisse() {
            if (this.selected_ecart == 'Écarts caisse') {
                this.by_type_ecart = ''
                this.total_ecart_caisse = this.rapport_caisse.total_ecart_caisse || 0
            } else if (this.selected_ecart == 'Écarts positifs') {
                this.by_type_ecart = 'ecart_positif'
                this.total_ecart_caisse = this.rapport_caisse.total_ecart_positif || 0
            } else if (this.selected_ecart == 'Écarts négatifs') {
                this.by_type_ecart = 'ecart_negatif'
                this.total_ecart_caisse = this.rapport_caisse.total_ecart_negatif || 0
            }
        }
    }
}
